var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgArrowsMid = function SvgArrowsMid(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.46436 6.46009L3.07636 5.75209C3.31636 5.47609 3.66436 5.30809 4.03636 5.30809H8.08036L7.81636 6.61609C7.74436 6.95209 8.12836 7.19209 8.40436 6.98809L11.7884 4.48009C11.9924 4.33609 11.9924 4.03609 11.7884 3.88009L8.40436 1.37209C8.12836 1.16809 7.74436 1.40809 7.81636 1.74409L8.08036 3.05209H3.96436C2.92036 3.05209 2.06836 3.90409 2.06836 4.94809V6.30409C2.06836 6.52009 2.33236 6.61609 2.46436 6.46009Z",
    fill: "#9595B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5356 7.53974L10.9236 8.24774C10.6836 8.52374 10.3356 8.69174 9.9636 8.69174H5.9196L6.1836 7.38374C6.2556 7.04774 5.8716 6.80774 5.5956 7.01174L2.21159 9.51974C2.00759 9.66374 2.00759 9.96374 2.21159 10.1197L5.5836 12.6277C5.8596 12.8317 6.2436 12.5917 6.1716 12.2557L5.9196 10.9477H10.0356C11.0796 10.9477 11.9316 10.0957 11.9316 9.05174V7.69574C11.9316 7.47974 11.6676 7.38374 11.5356 7.53974Z",
    fill: "#9595B1"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowsMid, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrowsMid.1171492e.svg";
export { ForwardRef as ReactComponent };